const randomize = require("randomatic");

// #10962 default service date window: today .. today+3 (Raw will have a lot of
// data, so the plugin should not open unfiltered). Cached user filters still win.
const isoDate = (offsetDays = 0) =>
  new Date(Date.now() + offsetDays * 24 * 60 * 60 * 1000)
    .toISOString()
    .split("T")[0];

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    main: true,
    props: {
      filterName: "itineraryRef_contains",
      label: "Itinerary ref",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "supplierName_contains",
      label: "Supplier name",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/SelectFilter"),
    props: {
      filterName: "included",
      label: "Included",
      filterValue: null,
      items: [
        { text: "All", value: null },
        { text: "Included", value: true },
        { text: "Not included", value: false },
      ],
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    main: true,
    props: {
      filterName: "serviceDate",
      label: "Service date between",
      filterValue: null,
    },
    defaultValue: {
      serviceDate_gte: isoDate(0),
      serviceDate_lte: isoDate(3),
    },
    defaultLabel: `${isoDate(0)} - ${isoDate(3)}`,
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "itineraryDate",
      label: "Itinerary date between",
      filterValue: null,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/luggage-transfers/list-filters.js